<template>
  <layout-basic>
    <b-container
      fluid
      class="mt-3"
    >
      <b-card class="data-card">
        <template v-slot:header>
          <h4 class="pt-0 flex-shrink-0 mr-auto align-self-center">
            Booking Report
          </h4>
          <div
            class="filter-wrapper"
            @keyup.enter="getData()"
          >
            <div class="time-date-group">
              <div class="mt-2 mr-2 time-label">
                From
              </div>
              <b-input
                v-model="$v.form.timeFrom.$model"
                class="time-input"
                type="time"
                :state="validateState('timeFrom')"
              />
              <date-picker
                v-model="filter.dateFrom"
                input-class="date-input"
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                :lang="lang"
              />
            </div>
            <div class="time-date-group">
              <div class="mt-2 mr-2 time-label">
                To
              </div>
              <b-input
                v-model="$v.form.timeTo.$model"
                class="time-input"
                type="time"
                :state="validateState('timeTo')"
              />
              <date-picker
                v-model="filter.dateTo"
                input-class="date-input"
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                :lang="lang"
              />
            </div>
            <div class="search-field-group">
              <b-form-input
                v-model="filter.driver"
                placeholder="Driver"
                class="search-field driver mb-1 mr-sm-2"
              />
              <b-form-input
                v-model="filter.passenger"
                placeholder="Passenger"
                class="search-field ml-md-2"
              />
            </div>
            <div
              id="car-status-dropdown"
              class="cars-dropdown car-status-dropdown ml-md-2"
            >
              <multiselect
                v-model="filter.status"
                placeholder="Status"
                :options="bookingStatuses"
                :searchable="false"
                select-label="✓"
                deselect-label="✗"
                selected-label=""
                :allow-empty="false"
              >
                <template
                  slot="option"
                  slot-scope="props"
                >
                  {{ props.option === -1 ? 'All' : '' }}
                  {{ props.option === constants.bookingStatus.Booked ? 'Booked' : '' }}
                  {{ props.option === constants.bookingStatus.Accepted? 'Accepted' : '' }}
                  {{ props.option === constants.bookingStatus.Cleared ? 'Cleared' : '' }}
                  {{ props.option === constants.bookingStatus.Allocated ? 'Allocated' : '' }}
                </template>
                <template
                  slot="singleLabel"
                  slot-scope="{ option }"
                >
                  {{ option === -1 ? 'All' : '' }}
                  {{ option === constants.bookingStatus.Booked ? 'Booked' : '' }}
                  {{ option === constants.bookingStatus.Accepted? 'Accepted' : '' }}
                  {{ option === constants.bookingStatus.Cleared ? 'Cleared' : '' }}
                  {{ option === constants.bookingStatus.Allocated ? 'Allocated' : '' }}
                </template>
              </multiselect>
            </div>
            <button
              class="btn btn-primary filter-action"
              @click="getData"
            >
              <i class="fa fa-sync-alt" />
            </button>
            <driver-modal />
          </div>
        </template>
        <b-table
          responsive="md"
          :items="bookingViewModals"
          :fields="fields"
          foot
          :tbody-tr-class="rowClass"
        >
          <template v-slot:cell(actions)="row">
            <a
              href="#"
              class="table-edit"
              @click="editBooking(row.item.id)"
            >
              <i class="fa fa-external-link-alt" />
            </a>
            <a
              href="#"
              class="table-delete"
              @click.stop="deleteBooking(row.item.id)"
            >
              <i class="fa fa-trash-alt" />
            </a>
          </template>
        </b-table>
        <b-row class="pl-3 pr-3 itemSelectorRow">
          <b-col cols="12" md class="itemSelectorColumn">
              <div>
                Items per page:
                <select v-model="perPage" class="custom-select">
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="250">250</option>
                  <option value="500">500</option>
                </select>
              </div>
          </b-col>
          <b-col cols="12" md>
          <div class="d-flex flex-column align-items-center pl-2 pr-2">
            <div class="d-flex align-items-center mb-3">
              Total bookings found: {{ totalCount }}
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalCount"
              :per-page="perPage"
              aria-controls="events-table"
              @change="onPageChange"
            />
          </div>
          </b-col>
          <b-col cols="0" md></b-col>
        </b-row>
        <booking-modal
          :value="bookingToEdit"
          :open="bookingModalOpen"
          :clear-booking-callback="clearBooking"
          @modal-closed="onBookingModalClose"
        />
      </b-card>
    </b-container>
  </layout-basic>
</template>

<script>
  import LayoutBasic from "@/layouts/LayoutBasic";
  import DriverModal from "@/components/BookingModal";
  import {mapGetters} from "vuex";
  import Constants from "../utils/Constants";
  import moment from 'moment'
  import Multiselect from 'vue-multiselect'
  import BookingModal from "../components/BookingModal";
  import DatePicker from "vue2-datepicker"
  import 'vue2-datepicker/locale/en';
  import {required} from "vuelidate/lib/validators";
  import validateStateMixin from "../mixins/validateStateMixin";

  const timeValidation = (value) => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value)

  export default {
    name: "Reporting",
    components: {
      LayoutBasic,
      DriverModal,
      Multiselect,
      BookingModal,
      DatePicker
    },
    data() {
      return {
        constants: Constants,
        dispatchStatuses: [],
        fields: [
          {key: "date", name: 'Date'},
          "time",
          "passenger",
          "driver",
          "phone",
          "from",
          "to",
          "status",
          {
            key: "actions",
            label: "",
            thClass: "tb-col-narrow"
          }
        ],
        bookings: [],
        bookingViewModals: [],
        totalCount: 0,
        perPage: 50,
        currentPage: 1,
        filter: {
          dateFrom: moment().subtract(7, "days").set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
          }).format('YYYY-MM-DD'),
          dateTo: moment().set({hour: 0, minute: 0, second: 0, millisecond: 0}).add(1,"days").format('YYYY-MM-DD'),
          driver: '',
          passenger: '',
          status: -1,
        },
        form:{
          timeFrom: moment().subtract(7, "days").set({hour: 0, minute: 0, second: 0, millisecond: 0}).format('HH:mm'),
          timeTo: moment().set({hour: 0, minute: 0, second: 0, millisecond: 0}).format('HH:mm'),
        },
        bookingModalOpen: false,
        bookingToEdit: null,
        lang: {
          formatLocale: {
            firstDayOfWeek: 1,
          },
          monthBeforeYear: false,
        }
      };
    },
    mixins: [validateStateMixin],
    validations: function(){
      return {
        form:{
          timeFrom: {
            required,
            timeValidation
          },
          timeTo:{
            required,
            timeValidation
          }
        }
      }
    },
    computed: {
      ...mapGetters(['selectedHeaderEvent'])
    },
    watch: {
      selectedHeaderEvent: async function () {
        await this.getData();
      },
      perPage: async function(){
        this.currentPage = 1;
        await this.getData();
      }
    },
    async created() {
      this.bookingStatuses = [-1].concat(Object.values(this.constants.bookingStatus))
      await this.getData();
    },
    methods: {
      async onPageChange(page) {
        this.currentPage = page;
        await this.getData();
      },
      async getData() {
        let vm = this;
        try {
          let bookingUrl = `bookings?searches[eventId]=${this.selectedHeaderEvent}&limit=${this.perPage}&page=${this.currentPage}`;
          if (this.filter.dateTo !== '' && this.form.timeTo !== '') {
            bookingUrl = `${bookingUrl}&searches[dateTo]=${moment(`${this.filter.dateTo} ${this.form.timeTo}`).toISOString()}`
          }
          if (this.filter.dateFrom !== '' && this.form.timeFrom !== '') {
            bookingUrl = `${bookingUrl}&searches[dateFrom]=${moment(`${this.filter.dateFrom} ${this.form.timeFrom}`).toISOString()}`
          }
          if (this.filter.driver !== '') {
            bookingUrl = `${bookingUrl}&searches[driver]=${this.filter.driver}`
          }
          if (this.filter.passenger !== '') {
            bookingUrl = `${bookingUrl}&searches[passenger]=${this.filter.passenger}`
          }
          if (this.filter.status > -1) {
            bookingUrl = `${bookingUrl}&searches[status]=${this.filter.status}`
          }
          let bookingsResponse = await this.$http.get(bookingUrl);
          this.bookings = bookingsResponse.data.items;
          this.bookingViewModals = this.bookings.map(booking => {
            return {
              date: vm.$options.filters.formatOnlyDate(booking.date),
              time: vm.$options.filters.formatOnlyTime(booking.date),
              passenger: booking.passengerName,
              driver: booking?.car?.driver ? `${booking.car.driver.firstName} ${booking.car.driver.lastName}` : '',
              phone: booking?.car?.driver ? booking?.car?.driver.phoneNumber : '',
              from: vm.$options.filters.formatAddress(booking.addressFrom),
              to: vm.$options.filters.formatAddress(booking.addressTo),
              status: vm.verboseStatus(booking.status),
              id: booking.id
            }
          });

          this.totalCount = bookingsResponse.data.totalCount
        } catch (error) {
          this.handleErrorResponse(error)
          throw error
        }
      },
      verboseStatus(status) {
        switch (status) {
          case this.constants.bookingStatus.Booked:
            return 'Booked';
          case this.constants.bookingStatus.Allocated:
            return 'Allocated';
          case this.constants.bookingStatus.Accepted:
            return 'Accepted';
          case this.constants.bookingStatus.Cleared:
            return 'Cleared';
          default:
            return '';
        }
      },
      rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.status === 'Cleared') return 'table-secondary'
      },
      async clearBooking(booking) {
        try {
          await this.$http.post(`bookings/${booking.id}/clear`);
          this.successAlert("The booking was successfully cleared");
        } catch (error) {
          this.handleErrorResponse(error)
        }
      },
      async onBookingModalClose() {
        this.bookingModalOpen = false;
        await this.getData();
      },
      editBooking(bookingId) {
        this.bookingToEdit = this.bookings.filter(booking=>{
          return booking.id === bookingId;
        })[0];
        this.bookingModalOpen = true;
      },
      async deleteBooking(bookingId){
        try {
          let confirmation = await this.$bvModal.msgBoxConfirm('Are you sure you want to delete this booking?', {
            okVariant: 'danger',
            okTitle: 'Delete',
          });
          if (!confirmation) return;
          await this.$http.delete(`bookings/${bookingId}`);
          await this.getData();
        } catch (error) {
          this.handleErrorResponse(error);
        }
      }
    },

  };
</script>

<style lang="scss" scoped>
  @import "@/assets/variables.scss";
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";

  .data-card .card-body {
    padding: 0px;
  }

  .data-card .card-header {
    padding-left: 12px;
    padding-right: 12px;

    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    align-items: start;

    @include media-breakpoint-down(md) {
      flex-wrap: wrap;
    }

    @include media-breakpoint-down(sm) {
      padding-left: 0px;
    }
  }

  .data-card .card-header > * {
    @include media-breakpoint-down(sm) {
      margin-bottom: 6px;
    }
  }

  .filter-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    max-width: 735px;


    @include media-breakpoint-down(sm) {
      justify-content: flex-start;
    }

  }

  .filter-wrapper > * {
    margin-left: 12px;

    @include media-breakpoint-down(sm) {
      margin-bottom: 6px;
    }

  }

  h4 {
    flex-basis: 220px;
    margin-bottom: 4px;

    @include media-breakpoint-down(md) {
      margin-bottom: 16px;
    }

    @include media-breakpoint-down(sm) {
      flex-basis: 100%;
      margin-left: 12px;
    }
  }

  .search-field-group {
    display: flex;
    flex-wrap: nowrap;
    flex-grow: 1;

     @include media-breakpoint-down(md) {
       flex-basis: 70%;
      flex-shrink: 0;
      flex-grow: 0;
      flex-wrap: nowrap;
     }

    @include media-breakpoint-only(sm) {
      flex-basis: 100%;
      padding-right: 12px;
    }

    @include media-breakpoint-only(xs) {
      flex-wrap: wrap;
    }

  }

  .search-field {

    flex-basis: 50px;
    flex-grow: 1;
    flex-shrink: 0;

    @include media-breakpoint-down(sm) {
      flex-basis: 50%;
      flex-grow: 0;
      flex-shrink: 1;
      order: 1;
    }

    @include media-breakpoint-down(xs) {
      flex-basis: 315px;
      flex-shrink: 0;
      flex-grow: 0;
    }

    &.driver {
      @include media-breakpoint-down(sm) {
        flex-basis: 315px;
        flex-grow: 0;
        flex-shrink: 0;
      }
      @include media-breakpoint-only(sm) {
        flex-basis: 51%;
        flex-grow: 1;
        flex-shrink: 0;
      }
    }
  }

  /deep/ .multiselect {
    min-width: unset !important;

    .multiselect__tags {
        .multiselect__single {
          padding-top: 2px;
        }
    }
  }

  .filter-action {
    margin-bottom: 6px;

    @include media-breakpoint-only(xs) {
         margin-right: 6px;
    }
 
  }

  .time-date-group {
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 6px;
    flex-basis: 315px;
    flex-grow: 0;
    flex-shrink: 0;

       @include media-breakpoint-only(sm) {
         flex-basis: 362px;
       }
  }

  .time-input {
    width: none;
    flex-basis: 100px;
    flex-shrink: 0;
    flex-grow: 0
  }

  .time-label {

    @include media-breakpoint-down(sm) {
      flex-basis: 50px;
      flex-shrink: 0;
      flex-grow: 1;
    }
  }

.mx-datepicker {

    margin-left: 8px;
    flex-basis: 100%;
    flex-grow: 1;
    flex-shrink: 1;
    width: unset;
  }


  .status-dropdown {
    align-self: flex-start;
  }

  /deep/ .tb-col-narrow {
    width: 75px !important;

    @include media-breakpoint-down(sm) {
      width: auto !important;
    }

  }

  .table-edit {
    margin-left: 3px;
    margin-right: 3px;

    i {
      color: $info;
    }
  }

  .table-delete {
    margin-left: 3px;
    margin-right: 3px;

    i {
      color: $danger;
    }

    @include media-breakpoint-down(sm) {
      margin-left: 0px;
    }
  }

  .multiselect {
    min-width: 200px;
  }

.car-status-dropdown {

  @include media-breakpoint-down(xl) {
    flex-basis: 140px;
  }

  @include media-breakpoint-down(sm){
  margin-left: 12px;
  flex-basis: 261px;
  }

  @include media-breakpoint-only(xs) {
    flex-basis:259px;
    
  }
}

  .car-status-dropdown::v-deep .multiselect {

    .multiselect__single {
      .car-msg-status {
        padding: 1px 6px 1px 6px;
        margin-top: 0px;
        margin-right: 8px;
        margin-bottom: 0px;
        line-height: 20px;
      }

      div {
        span {
          padding-top: 2px;
        }
      }
    }

    .multiselect__content-wrapper {
      .multiselect__content {
        .multiselect__element {
          .multiselect__option {
            min-height: unset !important;

            div {
              .car-msg-status {
                padding: 1px 6px 1px 6px;
                margin-bottom: 0px;
                line-height: 20px;
                margin-right: 8px;
              }

              span {
                padding-top: 4px;
              }
            }
          }
        }
      }
    }
  }

  .small-button {
    padding-top: 0px;
    padding-bottom: 2px;
  }

  .custom-select{
    width:auto;
  }

.itemSelectorColumn {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding-bottom: 16px;

  @include media-breakpoint-down(sm) {
    justify-content: center;
  }
}

.itemSelectorRow {

  @include media-breakpoint-down(sm) {
    flex-direction: column-reverse;
  }
}

</style>